import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {v4 as uuidv4} from 'uuid';
import AddCustomerServiceNotesOverlayDialog from '../../dialogs/addCustomerServiceNotesOverlayDialog';
import ConfirmSaveYesNoOverlayDialog from '../../dialogs/confirmSaveYesNoOverlayDialog';
import ConfirmReleaseYesNoOverlayDialog from '../../dialogs/confirmReleaseYesNoOverlayDialog';
import ConfirmReleaseSDSNextDayDeliveryDialog from '../../dialogs/confirmReleaseSDSNextDayDeliveryDialog';
import OrderStatusOverlayDialog from '../../dialogs/orderStatusOverlayDialog';
import ConfirmDeleteCartOverlayDialog from '../../dialogs/confirmDeleteCartOverlayDialog';
import PayByCreditCardOverlayDialog from '../../dialogs/payByCreditCardOverlayDialog';
import AvailabilityMismatchAndUpdateActionOverlayDialog from '../../dialogs/availabilityMismatchAndUpdateActionOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

import _ from 'lodash';

import { routes } from '../../../redux/api/routes';
let { cyberSourceRedirectURL, cyberSourceURL, accessKey, profileId, showDebuggerConsoles } = routes;

import moment from 'moment';

import {
	createNewOrder,
	getTax,
	decliningBalance,
	addToCart,
	saveToCart,
	getCyberSource,
	cancelOrderDetails,
	saveCreateOrderPayloadBackup,
	getOrderDetails,
	isOrderPlaced,
	saveOrderShippingDetails,
	saveCreateOrderPayload,
	saveManageOrdersListBackup,
	dropProductSpecsEmail,
	resetErrorDetails,
	saveIsOrderCreatedWithNewAddress,
	// getCardTransaction,
	// modifyCart,
} from '../../../redux/actions';

class OrderReview extends Component {

	constructor(props) {
        super(props);

		var transaction_uuidf = uuidv4,
			date = new Date(),
			signed_date_time = date.toISOString();
		signed_date_time = signed_date_time.substring(0, signed_date_time.indexOf('.'));
		signed_date_time += 'Z';

        this.state = {
			errorMessage: '',
			payByCreditCardError: '',
			showAddCustomerServiceNotesOverlayDialog: false,
			showConfirmDeleteCartOverlayDialog: false,
            showConfirmSaveYesNoOverlayDialog: false,
			showConfirmReleaseYesNoOverlayDialog: false,
			showConfirmReleaseSDSNextDayDeliveryDialog: false,
			showPayByCreditCardOverlayDialog: false,
			showAvailabilityMismatchAndUpdateActionOverlayDialog: false,

			// Currently pay by credit card is not available so set this flag false so that it will show dialog
			isPayByCreditCardAvailable: true,

			createOrderPayload: null,

			noOfCreateOrderCalls: null,
			completedCreateOrderCalls: 0,
			completedOrderId: [],
			transactionId: null,
			email: null,

			showOrderStatusOverlayDialog: false,

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			duplicatePOMsg: "",
			whichOrder: '',
			editOrderErrorOccured: '',

			payload: {
				//Hard coded Values
				skip_decision_manager: true,
				profile_id: profileId,
				access_key: accessKey,
				transaction_uuid: transaction_uuidf(),
				signed_field_names: "access_key,profile_id,transaction_uuid,signed_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,override_custom_receipt_page,override_custom_cancel_page,skip_decision_manager,payment_method,bill_to_forename,bill_to_surname,bill_to_middleinitial,bill_to_address_line1,bill_to_address_line2,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,bill_to_email,bill_to_company_name",
				locale: "en",
				transaction_type: "create_payment_token",
				currency: "USD",
				signed_date_time: signed_date_time,
				// reference_number: "CustomerNet-1001", // new Date().getTime(),
				reference_number: (new Date().getTime()) + "-1001",
				bill_to_address_country: "US",
				override_custom_receipt_page: cyberSourceRedirectURL,
				override_custom_cancel_page: cyberSourceRedirectURL,

				//Dynamic Values
				amount: '',
				payment_method: 'card',

				bill_to_email: '',
				bill_to_forename: '',
				bill_to_middleinitial: '',
	            bill_to_surname: '',
				bill_to_company_name: '',
	            bill_to_address_line1: '',
	            bill_to_address_line2: '',
	            bill_to_address_city: '',
	            bill_to_address_postal_code: '',
	            bill_to_address_state: ''
			},
        };
		this.handleDialog = this.handleDialog.bind(this);
		this.checkIfAnyItemIsNotHoldBackOrder = this.checkIfAnyItemIsNotHoldBackOrder.bind(this);
		this.checkIfAnyInventoryFinancing = this.checkIfAnyInventoryFinancing.bind(this);
		this.isPriceOrderServiceIsDown = this.isPriceOrderServiceIsDown.bind(this);
		this.handleRemoveAllCart = this.handleRemoveAllCart.bind(this);
		this.preparePayloadOfCurrentDelivery = this.preparePayloadOfCurrentDelivery.bind(this);
		this.checkIfStateIsAk = this.checkIfStateIsAk.bind(this);
		this.handleFetchOrderDetails = this.handleFetchOrderDetails.bind(this);
		this.updateAvailability = this.updateAvailability.bind(this);
		this.checkPayload = this.checkPayload.bind(this);
		this.checkAndConvertFedEx = this.checkAndConvertFedEx.bind(this);
    }

	componentWillMount() {
		const self = this;
		const { createOrderPayload } = self.props.state.order;
		let orderCreatedFrom = '';
		if(createOrderPayload && createOrderPayload.items && createOrderPayload.items.length) {
			orderCreatedFrom = createOrderPayload.items[0].redirectFrom;
		}
		self.setState({
			whichOrder: this.props.params.whichOrder,
			orderCreatedFrom
		});
		self.props.isOrderPlaced(false);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	getShippingAddressZipCode(params) {
		const { shippingAddress } = params;
		return shippingAddress && shippingAddress.zip && shippingAddress.zip.split("-")[0];
	}

	getLocTypeAccordingToDeliveryMethod(payload) {
		const record = _.find(this.props.state.order.pickAgentId, {deliveryMethod: payload.deliveryMethod});
		return record && record.loctype ? record.loctype : null;
	}

	preparePayloadOfCurrentDelivery(deliveryItems, createOrderPayload, whichDate) {
		const self = this;
		deliveryItems = JSON.parse(JSON.stringify(deliveryItems));
		createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));

		let quantity = 0;
		let orderSubTotal = 0.00;
		let tariffSurcharge = 0.00;
		let estimatedTax = 0.00;
		createOrderPayload.requestedDeliveryDate = createOrderPayload[whichDate];
		const agreementNumber = [];
		deliveryItems.forEach(item => {
			item.requestedDeliveryDate = createOrderPayload[whichDate];
			estimatedTax = item.estimatedTax;
			if(item.quantity) {
				if (item.item.toLowerCase().indexOf('delivery') === -1 &&
					item.item.toLowerCase().indexOf('charge') === -1
				) {
					quantity += parseInt(item.quantity, 10);
				}
				if(item.price) {
					orderSubTotal += parseFloat(parseFloat(item.quantity * item.price).toFixed(2));
				}
			}
			item.relatedServices && item.relatedServices.forEach(itm => {
				itm.extendedPrice = parseFloat(itm.price * itm.quantity).toFixed(2);
				itm.extendedPrice = parseFloat(itm.extendedPrice);
				if(itm.tariffBagItem) {
					tariffSurcharge += parseFloat(itm.extendedPrice);
				} else {
					orderSubTotal += parseFloat(itm.extendedPrice);
				}
			});
			if (!(item.item === "CUSTOMER MINIMUM DELIVERY" || item.item === 'HANDLING CHARGE' || item.item === 'LTL FREIGHT CHARGE') &&
				agreementNumber.indexOf(item.agreementNumber) === -1
			) {
				agreementNumber.push(item.agreementNumber);
			}
		});

		delete createOrderPayload.requestedDeliveryDate2;
		delete createOrderPayload.requestedDeliveryDate3;

		estimatedTax = parseFloat(estimatedTax).toFixed(2);
		let payload = {
			...createOrderPayload,
			items: deliveryItems,
			quantity,
			estimatedTax,
			orderSubTotal: parseFloat(orderSubTotal).toFixed(2),
			tariffSurcharge: parseFloat(tariffSurcharge).toFixed(2),
			orderTotal: parseFloat(parseFloat(estimatedTax) + orderSubTotal + tariffSurcharge).toFixed(2),
			pointValue: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.pointValue : 0).toFixed(2),
			orderWeight: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.weight : 0).toFixed(2),
		};
		// set agreement number at root level in payload if all items are having same agreement number
		const { selectedPriceSource } = self.props.state.user;
		payload = {
			...payload,
			agreementNumber: agreementNumber.length === 1 ? agreementNumber[0] : selectedPriceSource.AGREEMENT_NUMBER
		};
		let { warehouseCode, warehouseName, warehouseLoctype } = payload;
		// For no "_" found then it means user changed it to some other value so we need to search for "-" and pick first value
		if (warehouseLoctype) {
			warehouseLoctype = warehouseLoctype.indexOf("_") !== -1 ? warehouseLoctype.split('_') : warehouseLoctype.split('-');
			warehouseLoctype = warehouseLoctype.length ? warehouseLoctype[0].toUpperCase() : '';
		}
		payload = {
			...payload,
			warehouseCodeForDisplay: `${warehouseLoctype}-${warehouseCode} ${warehouseName}`
		};
	
		return payload;
	}

	checkIfStateIsAk(createOrderPayload) {
		let flag = false;
		if(createOrderPayload &&
			(
				(createOrderPayload.shippingAddress && createOrderPayload.shippingAddress.state === 'AK') ||
				createOrderPayload.deliveryMethod.indexOf('Ocean') !== -1
			)
		) {
			flag = true;
		}
		return flag;
	}

	groupPayloadByShipDateAndRDD(createOrderPayload, updateRequestedDeliveryDate, groupByHoldBackorders = false, selectedPriceSource , createOrderPayloadBackup){
		const self = this;
		let finalCreateOrderPayload = [];
		createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));
		let LocalStorageVarRDD =JSON.parse( localStorage.getItem( "RDDate" ) );
		const delivery1Items = createOrderPayload.items.filter(item => {
			if(item.originalOrderNumber !=null && item.shipDate ==""){
				item.shipDate = moment().format('MM/DD/YYYY')
			}
			return moment(item.shipDate).isSameOrBefore(moment(LocalStorageVarRDD))
		});
		const deliverynItems = createOrderPayload.items.filter(item => moment(item.shipDate).isAfter(moment(LocalStorageVarRDD)));
		let whichRequestedDeliveryDate = [];
		if(delivery1Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery1Items, createOrderPayload, 'requestedDeliveryDate', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate',
				delivery: 'delivery1',
				date: payload.items[0].requestedDeliveryDate
			});
		}
		if(deliverynItems.length > 0) {
			deliverynItems.map((item , index)=>{
				let deliveryItem =[];
				deliveryItem.push(item);
				let payload = self.preparePayloadOfCurrentDelivery(deliveryItem, createOrderPayload, 'requestedDeliveryDate', updateRequestedDeliveryDate);
				finalCreateOrderPayload.push(payload);
				whichRequestedDeliveryDate.push({
					which: 'requestedDeliveryDate',
					delivery: `delivery+${index+2}`,
					date: deliveryItem[0].requestedDeliveryDate
				});
				deliveryItem=[];
			})
		}
		return finalCreateOrderPayload;
	}

	groupPayloadByDelivery(createOrderPayload, updateRequestedDeliveryDate, groupByHoldBackorders = false) {
		const self = this;
		let finalCreateOrderPayload = [];
		createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));
		let holdItems = [];
		if(groupByHoldBackorders) {
			holdItems = JSON.parse(JSON.stringify(createOrderPayload.items)).filter(item => item.onHold === 'Y');
		}
		// Exclude all hold back order items and then prepare group
		createOrderPayload.items = JSON.parse(JSON.stringify(createOrderPayload.items)).filter(item => item.onHold !== 'Y');

		const delivery1Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery1');
		const delivery2Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery2');
		const delivery3Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery3');

		let whichRequestedDeliveryDate = [];
		if(delivery1Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery1Items, createOrderPayload, 'requestedDeliveryDate', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate',
				delivery: 'delivery1',
				date: payload.items[0].requestedDeliveryDate
			});
		}
		if(delivery2Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery2Items, createOrderPayload, 'requestedDeliveryDate2', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate2',
				delivery: 'delivery2',
				date: payload.items[0].requestedDeliveryDate
			});
		}
		if(delivery3Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery3Items, createOrderPayload, 'requestedDeliveryDate3', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate3',
				delivery: 'delivery3',
				date: payload.items[0].requestedDeliveryDate
			});
		}

		// Check if group by holds and some hold items are there
		finalCreateOrderPayload = groupByHoldBackorders ? [] : finalCreateOrderPayload;
		if(groupByHoldBackorders && holdItems.length) {
			// 	single delivery -> there will be separate delivery item or no any other delivery except holds
			if(finalCreateOrderPayload.length === 1 || finalCreateOrderPayload.length === 0) {
				const reqDate = holdItems[0].requestedDeliveryDate;
				const which = reqDate === 'delivery1' ? 'requestedDeliveryDate' : (reqDate === 'delivery2' ? 'requestedDeliveryDate2' : 'requestedDeliveryDate3');
				finalCreateOrderPayload.push(
					self.preparePayloadOfCurrentDelivery(holdItems, createOrderPayload, which, updateRequestedDeliveryDate)
				);
			}
			// 	multiple delivery -> it will pick which ever is the earliest
			else {
				let latestRequestedDeliveryDate = whichRequestedDeliveryDate[0];
				whichRequestedDeliveryDate.forEach(item => {
					const reqDelDate = item.date;
					if(moment(reqDelDate).isBefore(moment(latestRequestedDeliveryDate.date))) {
						latestRequestedDeliveryDate = item;
					}
				});
				finalCreateOrderPayload.push(
					self.preparePayloadOfCurrentDelivery(holdItems, createOrderPayload, latestRequestedDeliveryDate.which, updateRequestedDeliveryDate)
				);
			}
		}
		return finalCreateOrderPayload;
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			transactionId = self.getParameterByName('TransactionId', window.location.href),
			email = self.getParameterByName('Email', window.location.href),
			payByCreditCardError = self.getParameterByName('error', window.location.href),
			localStrogeOrderReviewStateObj = localStorage.getItem('orderReviewStateCnet');

		localStorage.removeItem('orderReviewStateCnet');
		const { selectedPriceSource } = self.props.state.user;
		const createOrderPayloadBackup = JSON.parse(JSON.stringify(self.props.state.order.createOrderPayloadBackup));

		if(payByCreditCardError) {
			showDebuggerConsoles && console.log('###### orderReview: componentDidMount -> payByCreditCardError');
			localStrogeOrderReviewStateObj = JSON.parse(localStrogeOrderReviewStateObj);
			this.setState({
				...localStrogeOrderReviewStateObj,
				payByCreditCardError
			})
		} else if(transactionId && email) {
			showDebuggerConsoles && console.log('###### orderReview: componentDidMount -> transactionId && email');
			localStrogeOrderReviewStateObj = JSON.parse(localStrogeOrderReviewStateObj);
			self.setState({
				...localStrogeOrderReviewStateObj,
				transactionId: transactionId,
				email: email
			}, () => {
				showDebuggerConsoles && console.log('###### orderReview: componentDidMount -> transactionId && email : before calling updateOrderStatus');
				//Make service call of release order as payment is already done
				self.updateOrderStatus('Create', 'showConfirmReleaseYesNoOverlayDialog');
			})
		} else if(!self.props.state.order.createOrderPayload) {
			browserHistory.push('/cart');
		} else {
			// Manipulate create order and group all items by delivery method in case of create order only
			const { selectedAccount } = self.props.state.user;
			let { createOrderPayload } = self.props.state.order;
			const customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE : "";
			createOrderPayload = {
				...createOrderPayload,
				customerClassCode
			};
			// add applyBulkHold attribute from getAccountResponsibility for create and edit order both
			const { accountResponsibilityData } = self.props.state.user;
			let applyBulkHold = '';
			if (accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject) {
				applyBulkHold = accountResponsibilityData.responseObject.applyBulkHold;
			}
			createOrderPayload.applyBulkHold = applyBulkHold;
			const finalCreateOrderPayloadByHoldBackorders = self.groupPayloadByDelivery(createOrderPayload, true, true);
			let finalCreateOrderPayload = [];
			if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && selectedPriceSource.AGREEMENT_TYPE == "Inventory Financing" && createOrderPayload && createOrderPayload.deliveryMethod == 'ADC Velocity' ){
				finalCreateOrderPayload= self.groupPayloadByShipDateAndRDD(createOrderPayload, true, false);
			}else{
				finalCreateOrderPayload= self.groupPayloadByDelivery(createOrderPayload, true, false);
			}
			let zipCode = '';
			// specific for hold back order condition set delivery method to ADC Truckload
			if(finalCreateOrderPayloadByHoldBackorders[0]) {
				zipCode = finalCreateOrderPayloadByHoldBackorders[0].shippingAddress.zip.split("-")[0];
			} else {
				zipCode = finalCreateOrderPayload[0].shippingAddress.zip.split("-")[0];
			}
			self.setState({
				isHoldBackOrderShippingDetailsCompleted: !finalCreateOrderPayloadByHoldBackorders[0],
				isNormalOrderShippingDetails1Completed: !finalCreateOrderPayload[0],
				isNormalOrderShippingDetails2Completed: !finalCreateOrderPayload[1],
				isNormalOrderShippingDetails3Completed: !finalCreateOrderPayload[2],
				holdBackOrdersShippingDetails: null,
				normalOrdersShippingDetails1: null,
				normalOrdersShippingDetails2: null,
				normalOrdersShippingDetails3: null,
				finalCreateOrderPayloadByHoldBackorders,
				finalCreateOrderPayload,
				isNewAddress: createOrderPayload.shippingAddress.newAddress
			}, () => {
				if (!self.state.isHoldBackOrderShippingDetailsCompleted) {
					self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
						self.setState({
							holdBackOrdersShippingDetails: resp,
							isHoldBackOrderShippingDetailsCompleted: true
						}, () => {
							self.callBackAfterShippingDetails();
						});
					},
					true,
					finalCreateOrderPayloadByHoldBackorders[0].shippingAddress.state,
					self.props.getSelectedAccountNumber(),
					finalCreateOrderPayloadByHoldBackorders[0].requestedDeliveryDate);
				}
				if (!self.state.isNormalOrderShippingDetails1Completed) {
					self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(finalCreateOrderPayload[0]), resp => {
						self.setState({
							normalOrdersShippingDetails1: resp,
							isNormalOrderShippingDetails1Completed: true
						}, () => {
							self.callBackAfterShippingDetails();
						});
					},
					true,
					finalCreateOrderPayload[0].shippingAddress.state,
					self.props.getSelectedAccountNumber(),
					finalCreateOrderPayload[0].deliveryMethod.indexOf("SDS") !== -1 ? finalCreateOrderPayload[0].requestedDeliveryDate : null);
				}
				if (!self.state.isNormalOrderShippingDetails2Completed) {
					self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(finalCreateOrderPayload[1]), resp => {
						self.setState({
							normalOrdersShippingDetails2: resp,
							isNormalOrderShippingDetails2Completed: true
						}, () => {
							self.callBackAfterShippingDetails();
						});
					},
					true,
					finalCreateOrderPayload[1].shippingAddress.state,
					self.props.getSelectedAccountNumber(),
					finalCreateOrderPayload[1].deliveryMethod.indexOf("SDS") !== -1 ? finalCreateOrderPayload[1].requestedDeliveryDate : null);
				}
				if (!self.state.isNormalOrderShippingDetails3Completed) {
					self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(finalCreateOrderPayload[2]), resp => {
						self.setState({
							normalOrdersShippingDetails3: resp,
							isNormalOrderShippingDetails3Completed: true
						}, () => {
							self.callBackAfterShippingDetails();
						});
					},
					true,
					finalCreateOrderPayload[2].shippingAddress.state,
					self.props.getSelectedAccountNumber(),
					finalCreateOrderPayload[2].deliveryMethod.indexOf("SDS") !== -1 ? finalCreateOrderPayload[2].requestedDeliveryDate : null);
				}
			});
		}
	}

	callBackAfterShippingDetails() {
		const self = this;
		const {
			isHoldBackOrderShippingDetailsCompleted,
			isNormalOrderShippingDetails1Completed,
			isNormalOrderShippingDetails2Completed,
			isNormalOrderShippingDetails3Completed,
		} = self.state;
		if (isHoldBackOrderShippingDetailsCompleted && isNormalOrderShippingDetails1Completed &&
			isNormalOrderShippingDetails2Completed && isNormalOrderShippingDetails3Completed
		) {
			const {
				finalCreateOrderPayloadByHoldBackorders,
				finalCreateOrderPayload,
				holdBackOrdersShippingDetails,
			} = self.state;
			// specific for hold back order condition set delivery method to ADC Truckload
			if(finalCreateOrderPayloadByHoldBackorders[0]) {
				// WCP-7566: When we send the NEW model on a Hold Backorder, we need to send the Distribution Start date as the REQUEST date (RDD) for that line
				const items = finalCreateOrderPayloadByHoldBackorders[0].items;
				items.forEach(item => {
					if (!item.originalOrderNumber && item.itemType !== "S" && item.geego_distribution_start_date && moment(item.geego_distribution_start_date).isAfter(moment())) {
						item.requestedDeliveryDate = moment(item.geego_distribution_start_date).format('MM/DD/YYYY');
					}
				});
				finalCreateOrderPayloadByHoldBackorders[0] = {
					...self.updateWarehouseCodeDetails(holdBackOrdersShippingDetails, finalCreateOrderPayloadByHoldBackorders[0]),
					items,
					deliveryMethod: 'ADC Truckload'
				};
			}
			let updatedPayload = [];
			if(finalCreateOrderPayload.length) {
				// if any change made by user then we need to keep it as it is
				if(finalCreateOrderPayload[0].defaultWarehouseDetails.warehouseCode !== finalCreateOrderPayload[0].warehouseCode) {
					updatedPayload = finalCreateOrderPayload;
				} else {
					// if any SDS then update it as per requested date
					finalCreateOrderPayload.forEach((payload, index) => {
						const resp = self.state[`normalOrdersShippingDetails${index + 1}`];
						updatedPayload.push({
							...self.updateWarehouseCodeDetails(resp, payload)
						});
					});
				}
			}
			self.setState({
				createOrderPayload: updatedPayload.concat(finalCreateOrderPayloadByHoldBackorders)
			});
		}
	}

	updateWarehouseCodeDetails(resp, payload) {
		const self = this;
		const {defaultWarehouseDetails, deliveryMethod} = self.props.state.order.createOrderPayload || {};
		let warehouseCode = "",	warehouseName = "",	warehouseCodeCity = "", warehouseLoctype = "";
		if(payload.isSDSWillCallValueUpdated && deliveryMethod === "SDS Will Call"){
			warehouseCode = payload.warehouseCode,
			warehouseName = payload.warehouseLoctype.split("-")[1],
			warehouseCodeCity = payload.warehouseCodeCity,
			warehouseLoctype = "sds_will_call";
			warehouseCodeForDisplay = payload.warehouseLoctype
		}else{
			warehouseCode = defaultWarehouseDetails.warehouseCode,
			warehouseName = defaultWarehouseDetails.warehouseName,
			warehouseCodeCity = defaultWarehouseDetails.warehouseCodeCity,
			warehouseLoctype = defaultWarehouseDetails.warehouseLoctype;
		}
		// For no "_" found then it means user changed it to some other value so we need to search for "-" and pick first value
		if (warehouseLoctype) {
			warehouseLoctype = warehouseLoctype.indexOf("_") !== -1 ? warehouseLoctype.split('_') : warehouseLoctype.split('-');
			warehouseLoctype = warehouseLoctype.length ? warehouseLoctype[0].toUpperCase() : '';
		}
		let warehouseCodeForDisplay = payload.isSDSWillCallValueUpdated? payload.warehouseCodeForDisplay : `${warehouseLoctype}-${warehouseCode} ${warehouseName}`;
		if(self.checkIfStateIsAk(payload)) {
			warehouseCodeForDisplay = payload.isSDSWillCallValueUpdated? payload.warehouseCodeForDisplay : `${warehouseCode} ${warehouseName}`;
		}
		payload = {
			...payload,
			warehouseCodeForDisplay,
			warehouseCode,
			warehouseName,
			warehouseCodeCity,
			warehouseLoctype,
		}
		//self.props.saveCreateOrderPayload(JSON.parse(JSON.stringify(payload)));
		return payload;
	}

	getShipMethod = deliveryMethod => {
		switch(deliveryMethod) {
			case 'LTIA Ocean Ocean Full Container':
				return 'LTIA-Ocean-Ocean-Full Container';
			case 'MATU Ocean Ocean Full Container':
				return 'MATU-Ocean-Ocean-Full Container';
			default:
				return deliveryMethod;
		}
	}

	updateAvailability(callback) {
		const self = this;
		const shipSetList = [],
			skuList = [];
		const { deliveryMethod, shippingAddress, items, requestedDeliveryDate, warehouseCode } = self.props.state.order.createOrderPayload;
		const shipMethod = this.getShipMethod(deliveryMethod);
		items.forEach((item, index) => {
			if(!item.item) return null;
			if((item.itemType === 'M' || item.itemType === 'A') && !item.originalOrderNumber && item.onHold !== 'Y' && item.onForce !== 'Y') {
				let finalProductionDate = null;
				if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
					finalProductionDate = moment(item.geego_final_production_date).format('MM/DD/YYYY');
				}
				if(self.validateFP(item) || item.onHold === 'Y') {
					skuList.push({
						itemNumber: item.item,
						identifier: index + 1,
						qty: item.quantity,
						shipSet: '',
						shipMethod,
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate,
						agreementNumber: item.agreementNumber,
						requestedDeliveryDate: requestedDeliveryDate || moment().format('MM/DD/YYYY')
					});
				} else {
					if (!shipSetList.find(itm => itm.requestedDeliveryDate === item.requestedDeliveryDate)) {
						shipSetList.push({
							requestedDeliveryDate: item.requestedDeliveryDate,
							shipSet: parseInt(item.requestedDeliveryDate.replace('delivery', ''), 10)
						});
					}
					skuList.push({
						itemNumber: item.item,
						qty: item.quantity,
						identifier: index + 1,
						shipSet: shipSetList.find(itm => itm.requestedDeliveryDate === item.requestedDeliveryDate).shipSet,
						shipMethod,
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate,
						agreementNumber: item.agreementNumber,
						requestedDeliveryDate: requestedDeliveryDate || moment().format('MM/DD/YYYY')
					});
				}
			}
		});
		if(skuList.length > 0) {
			self.setState({
				orderAvailabilityCompleted: false,
				availabilityError: false,
			}, () => {
				// availability call
				const data = shippingAddress;
				const zipCode = data ? data.zip.split('-')[0] : '';
						// new availability call
						const payload = {
							accountNumber: self.props.getSelectedAccountNumber(),
							warehouseCode,
							customerSiteId: data.addressId,
							orderSource: '',
							state: data.state,
							country: data.country || "",
							tradingPartnerId:'',
							dateType:'ARRIVAL',
							items: skuList,
							zipCode: data.country ? zipCode : zipCode && zipCode.slice(0, 5)
						};
						self.props.checkAvailabilityForOrder(payload, response => {
							const availabilityData = response;
							// check existing availability with new availability if it is still available or not
							let showAvailabilityMismatchAndUpdateActionOverlayDialog = false;
							const existingItems = JSON.parse(JSON.stringify(self.props.state.order.createOrderPayload.items));
							const updatedItems = [];
							existingItems.forEach((itm, index) => {
								if((itm.itemType === 'M' || itm.itemType === 'A') && !itm.originalOrderNumber && itm.onHold !== 'Y' && itm.onForce !== 'Y') {
									let availability = availabilityData && availabilityData.find(it => it.itemNumber === itm.item && it.identifier === index + 1);
									if (availability && itm.quantity > availability.requestedDateQuantity) {
										updatedItems.push({
											...itm,
											availability: availability.requestedDateQuantity,
											eta: self.props.pickTheDateFromString(availability.arrivalDate),
											arrivalDate: self.props.pickTheDateFromString(availability.arrivalDate),
											groupArrivalDate: self.props.pickTheDateFromString(availability.groupArrivalDate),
											groupShipDate: self.props.pickTheDateFromString(availability.groupShipDate),
											groupShipDateBkp: self.props.pickTheDateFromString(availability.groupShipDate),
											shipDate: self.props.pickTheDateFromString(availability.shipDate),
										});
										showAvailabilityMismatchAndUpdateActionOverlayDialog = true;
									} else {
										updatedItems.push(itm);
									}
								} else {
									updatedItems.push(itm);
								}
							});
							// if any old availability and new not matching then show popup and redirect user to previous step
							// if (showAvailabilityMismatchAndUpdateActionOverlayDialog) {
							// 	self.props.saveCreateOrderPayload({
							// 		...self.props.state.order.createOrderPayload,
							// 		items: updatedItems
							// 	});
							// 	self.handleDialog('AvailabilityMismatchAndUpdateActionOverlayDialog', true);
							// } else {
								callback && callback();
							//}
						});
			});
		} else {
			callback && callback();
		}
	}

	handleReleaseOrder(event) {
		event && event.preventDefault();
		const self = this;
		const { selectedAccount } = self.props.state.user;
		if (selectedAccount && selectedAccount.PAYMENTTERMS === 'Prepayment' && self.checkIfAnyItemIsNotHoldBackOrder()) {
			self.setState({
				genericDialogHeading: "Payment Terms",
				genericDialogText: self.state.whichOrder === 'createorder' ? "Since your payment terms is prepayment please proceed with pay by credit card option." : "Please contact Customer Service to book this order using a credit card.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true);
			});
		} else {
			if(self.props.state.order.createOrderPayload.deliveryMethod === "SDS Delivery Next Day") {
				self.handleDialog("ConfirmReleaseSDSNextDayDeliveryDialog", true);
			} else {
				self.handleDialog("ConfirmReleaseYesNoOverlayDialog", true);
			}
		}
		localStorage.removeItem("RDDate")
	}

	handleSaveOrder(event) {
		event.preventDefault();
		this.handleDialog("ConfirmSaveYesNoOverlayDialog", true);
		localStorage.removeItem("RDDate")
	}

	handleAddNotes(notes) {
		//Handle notes here
		let { createOrderPayload } = this.state;
		createOrderPayload.forEach(item => {
			item.customerServiceNotesOrg = notes;
			item.customerServiceNotes = notes;
		});
		this.setState({
			createOrderPayload,
			showAddCustomerServiceNotesOverlayDialog: false
		})
	}

	handleRemoveAllCart(callback) {
      	const self = this,
	  		{ selectedAccount, userDetails } = self.props.state.user;
      	let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems: []
      	};
		// const cartItems = self.props.state.cart.cart.responseObject.cartItems;
		// const { availability } = self.props.state.cart;
		// cartItems.forEach(item => {
		// 	products.push({
		// 		name: item.itemDescription,
		// 		id: item.item,
		// 		price: self.props.formatMoney(item.price, 0, ".", ",", false, ""),
		// 		brand: item.brand,
		// 		category: item.category,
		// 		variant: undefined,
		// 		quantity: item.quantity,
		// 		dimension70: item.originalOrderNumber ? 'no' : (item.quantity > item.availability ? 'yes' : 'no'),
		// 	});
		// });
		// // populate below undefined fields
		// self.props.fireGTMTag('Remove from Cart', {
		// 	ecommerce: {
		// 		currencyCode: 'USD',
		// 		remove: {
		// 			products
		// 		}
		// 	}
		// });
		self.props.addToCart(payload, response => {
			if (response.status) {
				if (response.responseObject) {
					self.props.saveToCart(response);
					callback && callback();
				}
			} else {
				browserHistory.push('/error');
			}
		});
    }


	updateOrderStatus(orderStatus, dialogName) {
		const self = this;
		self.setState({
			[dialogName]: false
		}, () => {
			// check availability default true, it will be only false in case of user is redirecting from pay by credit card
			//		to order review then we have to ignore update availability call as user has already paid the amount
			const { transactionId, email } = self.state;
			const checkAvailability = transactionId && email ? false : true;
			// if its create type means BOOK ORDER then declining balance service needs to make
			if(orderStatus === 'Create') {
				if (checkAvailability) {
					self.updateAvailability(() => {
						if(self.props.state.order.decliningBalanceNewAccountClassification.indexOf(self.props.customerClassCodeOfSelectedAccount.toLowerCase()) === -1){
							self.getDecliningBalanceData(() => {
								self.continueUpdateOrderStatus(orderStatus);
							});
						}else{
							self.continueUpdateOrderStatus(orderStatus);
						}
					});
				} else {
					if(self.props.state.order.decliningBalanceNewAccountClassification.indexOf(self.props.customerClassCodeOfSelectedAccount.toLowerCase()) === -1){
							self.getDecliningBalanceData(() => {
								self.continueUpdateOrderStatus(orderStatus);
							});
						}else{
							self.continueUpdateOrderStatus(orderStatus);
						}
				}
			} else {
				self.continueUpdateOrderStatus(orderStatus);
			}
		});
	}

	checkAndConvertFedEx(payload) {
		const self = this;
		const backorderItems = self.props.state.order.backOrders !== null && self.props.state.order.backOrders.responseObject.flatMap(order =>
			order.orderDetail.orderLine.map(orderLine => orderLine.item)
		  );
		  const backOdrItmInPayload = backorderItems && payload.items.filter(payloadItem =>
			backorderItems.includes(payloadItem.item)
		  );
		if(payload && payload.deliveryMethod === 'FedEx Ground') {
			payload = JSON.parse(JSON.stringify(payload));
			const items = [];
			payload.items.forEach(item => {
				let backOrderItem = backOdrItmInPayload && backOdrItmInPayload.filter(backOrder => backOrder.item === item.item );
				let isBackOrderItem = backOrderItem && backOrderItem.length > 0 ? true : false;
				if(item.quantity > 1 && !isBackOrderItem) {
					_.times(item.quantity, (indx) => {
						if(indx > 0 && self.state.whichOrder === 'editorder' && item.quantity > item.originalQuantity) {
							items.push({
								...item,
								quantity: 1,
								action: 'new',
							});
						} else {
							items.push({
								...item,
								quantity: 1,
							});
						}
						return null;
					});
				} else {
					if(isBackOrderItem && item.quantity > 1) {
						payload.deliveryMethod = 'FDSS-Parcel-GEA_Truck'
					}
					items.push(item);
				}
			});
			payload.items = items;
		}
		return payload;
	}

	getDecliningBalanceData(callback) {
		const self = this;
		const { createOrderPayload } = self.state;
		// declining balance service call
		const decliningBalancePayload = [];
		createOrderPayload.forEach((payload, index) => {
			payload.items.forEach((item, ind) => {
				if (item.onHold !== 'Y' && (item.itemType === 'M' || item.itemType === 'A' || item.itemType === 'S')) {
					decliningBalancePayload.push({
						customernumber: "",
						salesagreementnumber: parseInt(item.agreementNumber, 10),
						ordereditem: item.item,
						extendedamount: item.price * item.quantity,
						lineidentifier: item.decliningLineNo,
						orderedquantity: parseInt(item.quantity, 10)
					});
					// if (item.relatedServices && item.relatedServices.length) {
					// 	item.relatedServices.forEach((itm, indx) => {
					// 		if(self.props.getItemTypeByName(itm.serviceId) === 'S') {
					// 			decliningBalancePayload.push({
					// 				customernumber: "",
					// 				salesagreementnumber: parseInt(item.agreementNumber, 10),
					// 				ordereditem: itm.serviceId,
					// 				extendedamount: itm.price * itm.quantity,
					// 				lineidentifier: itm.decliningLineNo,
					// 				orderedquantity: parseInt(itm.quantity, 10)
					// 			});
					// 		}
					// 	});
					// }
				}
			});
		});
		if (decliningBalancePayload.length) {
			self.props.decliningBalance(decliningBalancePayload, response => {
				if (response && response.status && response.responseObject && response.responseObject.declinebalinpdetails &&
					response.responseObject.declinebalinpdetails.length
				) {
					const { createOrderPayload } = self.state;
					const decliningBalanceResponse = response.responseObject.declinebalinpdetails;
					createOrderPayload.forEach((payload, index) => {
						payload.items.forEach((item, ind) => {
							if(item.itemType === 'M' || item.itemType === 'A' || item.itemType === 'S') {
								const decliningBalanceDetail = decliningBalanceResponse.find(record => record.lineidentifier === item.decliningLineNo.toString());
								if (decliningBalanceDetail) {
									item.dbholdflag = decliningBalanceDetail.dbholdflag;
									item.holdcomments = decliningBalanceDetail.holdcomments;
								}
								if(item.relatedServices && item.relatedServices.length) {
									item.relatedServices.forEach((itm, indx) => {
										if (itm.itemType === 'S') {
											const decliningBalanceDetail2 = decliningBalanceResponse.find(record => record.lineidentifier === (item.decliningLineNo.toString() + '.' + indx.toString()));
											if (decliningBalanceDetail2) {
												itm.dbholdflag = decliningBalanceDetail2.dbholdflag;
												itm.holdcomments = decliningBalanceDetail2.holdcomments;
											}
										}
									});
								}
							}
						});
					});
					self.setState({
						createOrderPayload
					}, () => {
						callback && callback();
					});
				} else {
					// Check the account classification. If the classification is in this list (SINGLE FAMILY, SINGLE FAMILY RENOVATION, OEM - DIRECT, GOVERNMENT, DIRECT PROPERTY MGT REHAB, DIRECT PROPERTY MGT REPLACEMENT) then proceed with booking the order.
					if(self.props.state.order.decliningBalanceAccountClassifications.indexOf(self.props.customerClassCodeOfSelectedAccount.toLowerCase()) !== -1) {
						callback && callback();
					} else {
						// If the account classification is NOT in the list above, then check the PRICE_LIST_NAME for the SA for each order line. For any line where the PRICE_LIST_NAME starts with “QUOTE”, put the line on DB hold and display the user message.
						const { selectedAccountsAllPriceSources } = self.props.state.user;
						createOrderPayload.forEach(payload => {
							payload.items.forEach(item => {
								if (item.onHold !== 'Y' && (item.itemType === 'M' || item.itemType === 'A' || item.itemType === 'S')) {
									const priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString());
									if (priceSourceDetails && priceSourceDetails["PRICE_LIST_NAME"].indexOf('QUOTE') === 0) {
										item.dbholdflag = 'Y';
									}
								}
							});
						});
						self.setState({
							createOrderPayload
						}, () => {
							callback && callback();
						});
					}
				}
			});
		} else {
			callback && callback();
		}
	}

	continueUpdateOrderStatus(orderStatus) {
		const self = this;
		const isThisAccountRestricted = self.props.isThisAccountRestricted;
		let { createOrderPayload } = this.state;
		createOrderPayload.map((itmCOP)=>{
			itmCOP.items.map((itemN)=>{
				itemN.requestedDeliveryDate = itmCOP.requestedDeliveryDate;
			})
		})
		// If user clicks on Enter Order to save that order only and
		if(orderStatus === 'Save') {
			createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));
			// if there is any onHold item then need to combile all item in single order
			const updatedCreatedOrderPayload = [];
			// First prepare only object without onHold items
			createOrderPayload.forEach(order => {
				if(!order.items.find(item => item.onHold === 'Y')) {
					updatedCreatedOrderPayload.push(order);
				}
			});
			// then iterate onhold items and merge it if it is already added in updatedCreatedOrderPayload
			createOrderPayload.forEach(order => {
				if(order.items.find(item => item.onHold === 'Y')) {
					const originalDelivery = order.items[0].originalDelivery;
					let index = -1;
					updatedCreatedOrderPayload.forEach((ord, ind) => {
						if(ord.items.find(item => item.originalDelivery === originalDelivery)) {
							index = ind;
						}
					});
					if(index !== -1) {
						// Merge it to existing items
						const backOrderItems = order.items;
						backOrderItems.forEach(item => {
							delete item.onHold;
						});
						updatedCreatedOrderPayload[index].items = updatedCreatedOrderPayload[index].items.concat(backOrderItems);
						updatedCreatedOrderPayload[index].pointValue = parseFloat(updatedCreatedOrderPayload[index].pointValue || 0) + parseFloat(order.pointValue || 0);
						updatedCreatedOrderPayload[index].orderWeight = parseFloat(updatedCreatedOrderPayload[index].orderWeight || 0) + parseFloat(order.orderWeight || 0);
						updatedCreatedOrderPayload[index].orderTax = parseFloat(updatedCreatedOrderPayload[index].orderTax || 0) + parseFloat(order.orderTax || 0);
						updatedCreatedOrderPayload[index].orderSubTotal = parseFloat(updatedCreatedOrderPayload[index].orderSubTotal || 0) + parseFloat(order.orderSubTotal || 0);
						updatedCreatedOrderPayload[index].orderTotal = parseFloat(updatedCreatedOrderPayload[index].orderTotal || 0) + parseFloat(order.orderTotal || 0);
						updatedCreatedOrderPayload[index].pointValue = parseFloat(updatedCreatedOrderPayload[index].pointValue).toFixed(2);
						updatedCreatedOrderPayload[index].orderWeight = parseFloat(updatedCreatedOrderPayload[index].orderWeight).toFixed(2);
						updatedCreatedOrderPayload[index].orderTax = parseFloat(updatedCreatedOrderPayload[index].orderTax).toFixed(2);
						updatedCreatedOrderPayload[index].orderSubTotal = parseFloat(updatedCreatedOrderPayload[index].orderSubTotal).toFixed(2);
						updatedCreatedOrderPayload[index].orderTotal = parseFloat(updatedCreatedOrderPayload[index].orderTotal).toFixed(2);
						updatedCreatedOrderPayload[index].hideEstimateGEAADCMsg = true;
					} else {
						// push it to list
						updatedCreatedOrderPayload.push({
							...order,
							hideEstimateGEAADCMsg: true
						});
					}
				}
			});
			createOrderPayload = updatedCreatedOrderPayload;
		}
		createOrderPayload.forEach(item => {
			item.orderStatus = isThisAccountRestricted ? 'Save' : orderStatus;
		});
		self.setState({
			errorMessage: '',
			confirmationMessage: '',
			createOrderPayload,
			orderStatus,
			completedOrderId: [],
			duplicatePOMsg: "",
			editOrderErrorOccured: "",
			noOfCreateOrderCalls: createOrderPayload.length,
			completedCreateOrderCalls: 0,
			deleteOrderCompleted: false,
		}, () => {
			let isDuplicatePONumber = false;
			const { bookedOrders } = self.props.state.order;
			if(orderStatus === "Create") {
				bookedOrders.forEach(item => {
					if(item.orderHeader.ponumber === self.state.createOrderPayload[0].poNumber) {
						isDuplicatePONumber = true;
					}
				});
				isDuplicatePONumber && self.setState({
					duplicatePOMsg: "You have entered a duplicate PO number"
				});
			}
			// Delete order number in case of edit order and multiple parallel calls
			if(self.state.whichOrder === "editorder" && self.state.noOfCreateOrderCalls > 1) {
				const cancelOrderPayload = JSON.parse(JSON.stringify(self.props.state.order.createOrderPayload));
				// make another single call to delete order
				self.props.cancelOrderDetails(cancelOrderPayload, 'requestType=cancelOrder', (response) => {
					if(!response.status && !response.responseObject) {
						self.setState({
							errorMessage: response.responseMessage
						})
					} else {
						self.setState({
							deleteOrderCompleted: true,
							orderNumberForError: '',
						}, () => {
							self.callbackAfterCreateOrderServiceCalls(orderStatus);
						});
					}
				});
			} else {
				// Not required to make call to delete order
				self.setState({
					deleteOrderCompleted: true,
					orderNumberForError: '',
				}, () => {
					self.callbackAfterCreateOrderServiceCalls(orderStatus);
				});
			}
			// Reset create order payload in store so that while spinning as well if user press browser back it will redirect to required page only
			self.props.saveCreateOrderPayload(null);
			self.props.saveCreateOrderPayloadBackup(null);
			self.props.saveManageOrdersListBackup(null);
			self.props.saveIsOrderCreatedWithNewAddress(self.state.isNewAddress);
			let updatedPayload = JSON.parse(JSON.stringify(createOrderPayload));
			if(self.state.whichOrder === 'createorder') {
				showDebuggerConsoles && console.log("##### orderReview : before removing all cart items");
				//self.handleRemoveAllCart();
				// If there are hold backorder items for any delivery > 50 items then split it like multiple delivery but no other change in payload
				updatedPayload = [];
				// This will be track for making tax service call for getting estimated tax details
				const anyHoldBackSplitForTax = [];
				createOrderPayload.forEach(payload => {
					const holdItems = payload.items.filter(itm => itm.onHold === 'Y');
					if(holdItems.length > 50) {
						const splitedHoldItems = _.chunk(holdItems, 50);
						splitedHoldItems.forEach((deliveryItems, index) => {
							let quantity = 0;
							let orderSubTotal = 0.00;
							let tariffSurcharge = 0.00;
							deliveryItems.forEach(item => {
								if(item.quantity) {
									quantity += parseInt(item.quantity, 10);
									if(item.price) {
										orderSubTotal += parseFloat(parseFloat(item.quantity * item.price).toFixed(2));
									}
								}
								item.relatedServices && item.relatedServices.forEach(itm => {
									itm.extendedPrice = parseFloat(itm.price * itm.quantity).toFixed(2);
									itm.extendedPrice = parseFloat(itm.extendedPrice);
									if(itm.tariffBagItem) {
										tariffSurcharge += parseFloat(itm.extendedPrice);
									} else {
										orderSubTotal += parseFloat(itm.extendedPrice);
									}
								});
							});
							updatedPayload.push({
								...payload,
								items: deliveryItems,
								quantity,
								orderSubTotal: parseFloat(orderSubTotal).toFixed(2),
								tariffSurcharge: parseFloat(tariffSurcharge).toFixed(2),
								orderTotal: parseFloat(orderSubTotal).toFixed(2),
								pointValue: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.pointValue : 0).toFixed(2),
								orderWeight: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.weight : 0).toFixed(2),
							});
							anyHoldBackSplitForTax.push({
								index: updatedPayload.length - 1,
								payload: updatedPayload[updatedPayload.length - 1]
							});
						});
					} else {
						updatedPayload.push(payload);
					}
				});
				if(anyHoldBackSplitForTax.length > 0) {
					// make parallel calls for tax
					self.setState({
						updatedPayload,
						anyHoldBackSplitForTax,
						noOfTaxParallelCalls: anyHoldBackSplitForTax.length,
						completedNoOfTaxParallelCalls: 0,
						taxDetailsFromParallelCalls: [],
					}, () => {
						// Need to make tax parallel calls and populated estimated tax field for each call.
						anyHoldBackSplitForTax.forEach((item) => {
							const payload = {
								...item.payload,
								shipFromAddress: JSON.parse(JSON.stringify(item.payload.shippingAddress))
							};
							self.props.getTax(payload, "requestType=getTax", resp => {
								if(resp.status && resp.responseObject) {
									const taxDetails = resp.responseObject;
									const { taxDetailsFromParallelCalls } = self.state;
									taxDetailsFromParallelCalls.push({
										index: item.index,
										taxDetails
									})
									self.setState({
										completedNoOfTaxParallelCalls: self.state.completedNoOfTaxParallelCalls + 1,
										taxDetailsFromParallelCalls
									}, () => {
										if (self.state.noOfTaxParallelCalls === self.state.completedNoOfTaxParallelCalls) {
											const updatedPayload = JSON.parse(JSON.stringify(self.state.updatedPayload));
											// update tax details for only those which are split for hold back order
											self.state.taxDetailsFromParallelCalls.forEach(item => {
												updatedPayload[item.index].estimatedTax = item.taxDetails.invoice.totaltaxamount;
												const {
													estimatedTax,
													orderSubTotal,
													tariffSurcharge,
												} = updatedPayload[item.index];
												updatedPayload[item.index].orderTotal = parseFloat(parseFloat(estimatedTax) + parseFloat(orderSubTotal) + parseFloat(tariffSurcharge)).toFixed(2);
											});
											// now we can continue as it is
											self.continueFurtherForMakingCalls(updatedPayload, orderStatus);
										}
									});
								} else {
									browserHistory.push("/error");
								}
							}, true, item.payload.shippingAddress.state);
						});
					});
				} else {
					// if its not split then it will continue as normal flow.
					self.continueFurtherForMakingCalls(updatedPayload, orderStatus);
				}
			} else {
				// For edit it should work as it is without checking for hold back order count split by 50
				self.continueFurtherForMakingCalls(updatedPayload, orderStatus);
			}
		});
	}

	checkPayload(payload) {
		let errorFlag = false;
		if (payload && payload.items && payload.items.find(item => item.originalOrderNumber && !item.lineNo)) {
			errorFlag = true;
		}
		if (errorFlag) {
			const { userDetails } = self.props.state.user;
			self.props.dropProductSpecsEmail({
				userId: userDetails.sso,
				errorDetails: JSON.stringify(payload)
			}, "emailType=sendErrorInfo&blankLineNumber=Y", response => {
				self.props.resetErrorDetails();
            });
		}
	}

	continueFurtherForMakingCalls(updatedPayload, orderStatus) {
		const self = this;
		self.setState({
			createOrderPayload: updatedPayload
		}, () => {
			const { deletedItems } = self.props.state.order;
			let {shippingAddress, accountNumber} = self.state.createOrderPayload[0] || {};
			let shippingValue   =  {...shippingAddress, shipToAccountNumber: accountNumber}
			self.state.createOrderPayload.forEach((itm, index) => {
				let payload = itm;
				payload.items.forEach(item => {
					if(item.attribute){
						let attribute12Data = item.attribute.find(item => item.name === "Attribute12");
						let attribute12 = attribute12Data ? attribute12Data.value: null;
						if(attribute12 != null) {
							item.unrelatedOriginalItem = item.item;
							item.item = attribute12;	
					   }
					}
				})
			   const substituteItem = payload.items.filter((itm) => itm.unrelatedOriginalItem && itm.unrelatedOriginalItem != null);
				if(substituteItem.length>0){
					payload.substituteFound = true;
				}
				if(!payload.items.find(item => item.onHold === 'Y') && self.state.transactionId && self.state.email) {
					payload = {
						...payload,
						transactionId: self.state.transactionId,
						email: self.state.email,
						shippingAddress: shippingValue,
					}
				}
				payload.orderTax = payload.estimatedTax;
				// concat deleted items to payload
				let items = payload.items.concat(deletedItems);
				items.forEach(it => {
					if(it.poNumber) {
						it.poNumber = it.poNumber.trim().toUpperCase();
					}
					const priceSourceDetails = it.agreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === it.agreementNumber.toString());
					if(priceSourceDetails) {
						it.agreementType = priceSourceDetails.AGREEMENT_TYPE;
					}
					it.shipSet = (index + 1)
				});
				const { userDetails, selectedPriceSource } = self.props.state.user;
				payload = {
					...payload,
					poNumber: payload.poNumber.trim().toUpperCase(),
					createdById: userDetails.sso,
					createdBy: userDetails.firstName + " " + userDetails.lastName,
					email: userDetails.email,
					accountNumber: self.props.getSelectedAccountNumber(),
					agreementType: selectedPriceSource.AGREEMENT_TYPE,
					items,
					deliveryPhone: payload.deliveryPhone.replace('(', '').replace(' ', '').replace(')', '').replace('-', ''),
					shippingAddress: shippingValue,
				}

				// Delete order number in case of edit order and multiple parallel calls
				if(self.state.whichOrder === "editorder" && self.state.noOfCreateOrderCalls > 1) {
					// As new order will be created so we need to delete existing order number from payload
					delete payload.orderNumber;
				}

				// edit order -> single delivery -> use this new boot api
				let useBootApi = false;
				if(self.state.whichOrder === "editorder" && self.state.noOfCreateOrderCalls === 1) {
					useBootApi = true;
				}

				if(payload.customerServiceNotesDefault) {
					payload.customerServiceNotes = payload.customerServiceNotesDefault + payload.customerServiceNotes;
				}
				if(payload.customerServiceNotesEntered) {
					payload.customerServiceNotes += payload.customerServiceNotesEntered;
				}
				//FeDex changes 
				payload = self.checkAndConvertFedEx(payload);

				// for book orer fire gtm tag
				if(orderStatus === "Create") {
					// Fire gtm tag
					const products = [];
					payload.items.forEach(item => {
						products.push({
							name: item.itemDescription,
							id: item.item,
							price: self.props.formatMoney(item.price, 0, ".", ",", false, ""),
							brand: item.brand,
							category: item.category,
							variant: undefined,
							quantity: item.quantity,
							dimension70: item.originalOrderNumber ? 'no' : (item.quantity > item.availability ? 'yes' : 'no'),
							dimension79: 1,
							dimension80: item.uncrateInd === 'Y' ? 'uncrated' : 'crated',
							dimension82: item.onForce === 'Y' ? 'force backorder' : (item.onHold === 'Y' ? 'hold backorder' : undefined)
						});
					});
					self.props.fireGTMTag('Checkout Step', {
						shippingMethod: payload.deliveryMethod,
						ecommerce:{
							currencyCode: 'USD',
							checkout: {
								actionField: {
									step: '3'
								},
								products
							}
						}
					});
				}
				if(userDetails.typeOfUser === 'employee' && !self.checkIfStateIsAk(payload) && (payload.deliveryMethod === 'ADC Truckload' || payload.deliveryMethod === 'ADC LTL') && payload.alternateADC) {
					let shippingData = payload.shippingData ? payload.shippingData: [];
					let deliveryMethodDataValue = payload.deliveryMethod.split(" ")[0];
					let deliveryMethodData = "";
					if(deliveryMethodDataValue === "SDS"){
						deliveryMethodData = "sds_loc";
					}else if(deliveryMethodDataValue === "ADC" || deliveryMethodDataValue.split("-")[0] === "MATU"){
						deliveryMethodData = "adc_loc";
					}if(payload.deliveryMethod === "SDS Will Call"){
						deliveryMethodData = "sds_will_call_loc"
					}
					let warehouseData = {};
					let ADCdata = [];
					if(payload.alternateADC !== payload.defaultAlternateADC || payload.deliveryMethod == "SDS Delivery"){
						warehouseData = {
							label: payload.warehouseCode,
							name: payload.warehouseName
						}
					}
					else{
						if(payload.isSDSWillCallValueUpdated && payload.deliveryMethod === "SDS Will Call"){
							payload = {
								...payload,
							warehouseCode: payload.warehouseCode,
							warehouseCodeCity: payload.warehouseCodeCity,
							warehouseCodeForDisplay : payload.warehouseCodeForDisplay,
							warehouseName: payload.warehouseName,
							warehouseLoctype: payload.warehouseLoctype,
							};
						}else{
							ADCdata = shippingData.filter( data => data.loctype === deliveryMethodData )
							let alternateADC = ADCdata.length > 0 ? ADCdata[0].agentid : ADCdata.agentid;
							warehouseData = self.props.state.user.adcList.find(itm => itm.label === alternateADC);
							payload = {
							...payload,
								warehouseCode: warehouseData ? warehouseData.label : ADCdata && ADCdata.length === 0 ? payload.warehouseCode : ADCdata && ADCdata.length > 0 ? ADCdata[0].agentid : ADCdata.agentid,
								warehouseCodeCity: ADCdata && ADCdata.length === 0 ? payload.warehouseCodeCity : (ADCdata && ADCdata.length > 0 ?ADCdata[0].dockcity : ADCdata.dockcity),
								warehouseCodeForDisplay : ADCdata && ADCdata.length === 0 ? payload.warehouseCodeForDisplay : (ADCdata && ADCdata.length>1 ? `${ADCdata[0].agentid} ${ADCdata[0].dockname}` : `${ADCdata.agentid} ${ADCdata.dockname}`),
								warehouseName: ADCdata && ADCdata.length === 0 ? payload.warehouseName : (ADCdata && ADCdata.length>1 ? ADCdata[0].dockname : ADCdata.dockname),
								warehouseLoctype: ADCdata && ADCdata.length === 0 ? payload.warehouseLoctype :(ADCdata && ADCdata.length>1 ? ADCdata[0].loctype : ADCdata.loctype)
							};
						}
					}
				}
				showDebuggerConsoles && console.log("##### orderReview : before calling create new order");
				// check and drop an email with payload in case back orders items are there but no lineNo added
				let shippingData = payload.shippingData ? payload.shippingData: [];
				let deliveryMethodDataValue = payload.deliveryMethod.split(" ")[0];
				let deliveryMethodData = "";
				if(deliveryMethodDataValue === "SDS"){
					deliveryMethodData = "sds_loc";
				}else if(deliveryMethodDataValue === "ADC" || deliveryMethodDataValue.split("-")[0] === "MATU"){
					deliveryMethodData = "adc_loc";
				} else if(deliveryMethodDataValue === "FedEx" ){
					deliveryMethodData = "adc_loc";
				} if(payload.deliveryMethod === "SDS Will Call"){
					deliveryMethodData = "sds_will_call_loc"
				}
				let warehouseData = {};
				let ADCdata = [];
				if(payload.alternateADC !== payload.defaultAlternateADC || payload.deliveryMethod == "SDS Delivery"){
					warehouseData = {
						label: payload.warehouseCode,
						name: payload.warehouseName
					}
				}
				else{
					if(payload.isSDSWillCallValueUpdated && payload.deliveryMethod === "SDS Will Call"){
						payload = {
							...payload,
						warehouseCode: payload.warehouseCode,
						warehouseCodeCity: payload.warehouseCodeCity,
						warehouseCodeForDisplay : payload.warehouseCodeForDisplay,
						warehouseName: payload.warehouseName,
						warehouseLoctype: payload.warehouseLoctype,
						};
					}else{
						ADCdata = shippingData.filter( data => data.loctype === deliveryMethodData )
						let alternateADC = ADCdata.length > 0 ? ADCdata[0].agentid : ADCdata.agentid;
						warehouseData = self.props.state.user.adcList.find(itm => itm.label === alternateADC);
						payload = {
						...payload,
							warehouseCode: warehouseData ? warehouseData.label : ADCdata && ADCdata.length === 0 ? payload.warehouseCode : ADCdata && ADCdata.length > 0 ? ADCdata[0].agentid : ADCdata.agentid,
							warehouseCodeCity: ADCdata && ADCdata.length === 0 ? payload.warehouseCodeCity : (ADCdata && ADCdata.length > 0 ?ADCdata[0].dockcity : ADCdata.dockcity),
							warehouseCodeForDisplay : ADCdata && ADCdata.length === 0 ? payload.warehouseCodeForDisplay : (ADCdata && ADCdata.length>1 ? `${ADCdata[0].agentid} ${ADCdata[0].dockname}` : `${ADCdata.agentid} ${ADCdata.dockname}`),
							warehouseName: ADCdata && ADCdata.length === 0 ? payload.warehouseName : (ADCdata && ADCdata.length>1 ? ADCdata[0].dockname : ADCdata.dockname),
							warehouseLoctype: ADCdata && ADCdata.length === 0 ? payload.warehouseLoctype :(ADCdata && ADCdata.length>1 ? ADCdata[0].loctype : ADCdata.loctype)
						};
					}
				}
				if (userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser) {
					payload.salesRepNum = self.props.getASMAndDSASMSSOList();
				}
				self.checkPayload(payload);
				self.props.createNewOrder(payload, "requestType=createOrder", useBootApi, response => {
					if(response.status) {
						const { completedOrderId } = self.state;
						if (self.state.whichOrder === 'createorder') {
							// Fire gtm tag for enter order click only
							if(self.state.orderStatus === 'Save') {
								self.props.fireGTMTag('Order Review Enter Order', {
									orderNumber: response.responseObject.orderNumber,
								});
							} else {
								const {
									deliveryMethod,
									requestedDeliveryDate,
									items,
									orderTotal,
									orderTax,
									orderNumber,
								} = response.responseObject;
								const products = [];
								let extendedPrice = 0;
								items.forEach(item => {
									item.relatedServices && item.relatedServices.forEach(itm => {
										extendedPrice += parseFloat(itm.extendedPrice);
									});
									products.push({
										name: item.itemDescription,
										id: item.item,
										price: self.props.formatMoney(item.price, 0, ".", ",", false, ""),
										brand: item.brand,
										category: item.itemCategory,
										variant: undefined,
										quantity: item.quantity,
										coupon: undefined,
										dimension70: item.originalOrderNumber ? 'no' : (item.quantity > item.availability ? 'yes' : 'no'),
										dimension72: orderNumber,
										dimension79: item.shipSet,
										dimension80: item.uncrateInd === 'Y' ? 'uncrated' : 'crated',
										dimension82: item.onForce === 'Y' ? 'force backorder' : (item.onHold === 'Y' ? 'hold backorder' : undefined)
									});
								});
								self.props.fireGTMTag('Transaction', {
									paymentType: undefined,
									shippingMethod: deliveryMethod,
									splitShipping: self.state.createOrderPayload.length > 1 ? 'yes' : 'no',
									promiseDate: requestedDeliveryDate,
									ecommerce: {
										currencyCode: 'USD',
										purchase: {
											actionField: {
												id: orderNumber,
												affiliation: 'ge appliances',
												revenue: orderTotal,
												shipping: extendedPrice,
												tax: orderTax,
												coupon: undefined
											},
											products
										}
									}
								});
							}
						}
						if(self.state.whichOrder === 'createorder') {
							completedOrderId.push({
								orderNumber: response.responseObject.orderNumber,
								response,
								shipSet: parseInt(response.responseObject.items[0].shipSet, 10)
							});
						} else { // for Edit order
							// if it is single delivery
							if(self.state.createOrderPayload.length === 1) {
								completedOrderId.push({
									orderNumber: response.responseObject.orderNumber !== undefined ? response.responseObject.orderNumber : self.state.createOrderPayload[0].orderNumber,
									response,
								});
							} else if(self.state.createOrderPayload.length > 1) {
								completedOrderId.push({
									orderNumber: response.responseObject.orderNumber,
									response,
									shipSet: parseInt(response.responseObject.items[0].shipSet, 10)
								});
							}
						}
						self.setState({
							completedCreateOrderCalls: self.state.completedCreateOrderCalls + 1,
							completedOrderId,
							orderNumberForError: '',
						}, () => {
							self.callbackAfterCreateOrderServiceCalls(orderStatus, response);
						})
						if(response.responseObject && response.responseObject.orderNumber){
							self.handleRemoveAllCart();
						}
					} else {
						browserHistory.push("/error");
					}
				});
			});
		});
	}

	callbackAfterCreateOrderServiceCalls(orderStatus, response = null) {
		const self = this;
		const { completedCreateOrderCalls, noOfCreateOrderCalls, deleteOrderCompleted, completedOrderId } = self.state;
		if(completedCreateOrderCalls === noOfCreateOrderCalls && deleteOrderCompleted) {
			if(self.state.whichOrder === 'createorder') {
				// As per discussion to avoid browser back spinner issue, reset cart on click of button itself. so commenting out below code
				// self.handleRemoveAllCart(() => {
					if(completedOrderId.find(itm => !itm.response || !itm.response.responseObject)) {
						self.setState({
							editOrderErrorOccured: `Unable to ${orderStatus === 'Create'?'Book':'Enter'} Order. Please review the order details and contact the CustomerNet Help Desk if you continue to experience this error.`
						});
					} else {
						self.setState({
							editOrderErrorOccured: '',
						}, () => {
							self.props.isOrderPlaced(true);
						});
					}
				// });
			} else {
				const erroredObject = completedOrderId.find(itm => !itm.response || !itm.response.responseObject);
				// In case of edit order and single delivery and service failed use responseMessage returned by service
				if(completedOrderId.length === 1 && erroredObject) {
					const editOrderErrorOccured = [];
					const responseMessage = erroredObject.response.responseMessage.split(',');
					editOrderErrorOccured.push(
						<span key={0}>Unable to {orderStatus === 'Create'?'Book':'Enter'} Order. Please review the order details and contact the CustomerNet Help Desk if you continue to experience this error.<br/></span>
					)
					responseMessage.forEach((error, index) => {
						editOrderErrorOccured.push(<span className={error.indexOf('Error') === -1 ? "green" : ""} key={index + 1}>{error}<br/></span>);
					})
					self.setState({
						editOrderErrorOccured,
						orderNumberForError: noOfCreateOrderCalls === 1 ? self.state.createOrderPayload.orderNumber : '',
					});
				} else if(completedOrderId.length > 1 && erroredObject) {
					self.setState({
						editOrderErrorOccured: `Unable to ${orderStatus === 'Create'?'Book':'Enter'} Order. Please review the order details and contact the CustomerNet Help Desk if you continue to experience this error.`,
						orderNumberForError: noOfCreateOrderCalls === 1 ? self.state.createOrderPayload.orderNumber : '',
					});
				} else {
					self.setState({
						editOrderErrorOccured: ''
					}, () => {
						self.props.isOrderPlaced(true);
					});
				}
			}
		}
	}

	handlePayByCreditCard(event) {
		event.preventDefault();
		const self = this;
		const { isPayByCreditCardAvailable } = self.state;
		if(isPayByCreditCardAvailable) {
			//Save state in localstorage to use when user comes back to this page from cyber source
			showDebuggerConsoles && console.log('#####order review : ', this.state);
			localStorage.setItem('orderReviewStateCnet', JSON.stringify(this.state));
			const {
				user: {
					userDetails: {
						email,
						firstName,
						lastName,
					}
				}
			} = self.props.state;
			const { billingAddress } = self.state.createOrderPayload[0];
			let orderTotal = 0.00;
			self.state.createOrderPayload.forEach(order => {
				if(!order.items.find(item => item.onHold === 'Y')) {
					orderTotal += parseFloat(order.orderTotal);
				}
			});
			let transaction_uuidf = uuidv4,
				date = new Date(),
				signed_date_time = date.toISOString();
			signed_date_time = signed_date_time.substring(0, signed_date_time.indexOf('.'));
			signed_date_time += 'Z';

			self.setState({
				payload: {
					...self.state.payload,
					transaction_uuid: transaction_uuidf(),
					signed_date_time,
					amount: parseFloat(orderTotal).toFixed(2),
					bill_to_email: email,
					bill_to_forename: firstName,
					bill_to_middleinitial: '',
					bill_to_surname: lastName,
					bill_to_address_line1: billingAddress.address1,
					bill_to_address_line2: billingAddress.address2,
					bill_to_address_city: billingAddress.city,
					bill_to_address_state: billingAddress.state,
					bill_to_address_postal_code: billingAddress.zip,
					reference_number: (new Date().getTime()) + "-1001",
				}
			}, () => {
				const {
					payload: {
						amount,
						bill_to_address_postal_code,
						transaction_uuid,
						signed_field_names,
						locale,
						transaction_type,
						bill_to_email,
						bill_to_address_country,
						bill_to_surname,
						bill_to_middleinitial,
						bill_to_address_line2,
						bill_to_address_line1,
						skip_decision_manager,
						profile_id,
						access_key,
						bill_to_address_city,
						currency,
						bill_to_forename,
						signed_date_time,
						payment_method,
						override_custom_receipt_page,
						override_custom_cancel_page,
						reference_number,
					}
				} = self.state;
				self.props.getCyberSource("amount="+amount+"&bill_to_address_postal_code="+bill_to_address_postal_code+"&bill_to_company_name="+this.state.payload.bill_to_company_name+"&bill_to_address_state="+this.state.payload.bill_to_address_state+"&transaction_uuid="+transaction_uuid
					+"&signed_field_names="+signed_field_names+"&locale="+locale+"&transaction_type="+transaction_type+"&bill_to_email="+bill_to_email+"&bill_to_address_country="+bill_to_address_country+"&bill_to_surname="+bill_to_surname+"&bill_to_middleinitial="+bill_to_middleinitial
					+"&bill_to_address_line2="+bill_to_address_line2+"&bill_to_address_line1="+bill_to_address_line1+"&profile_id="+profile_id+"&access_key="+access_key+"&bill_to_address_city="+bill_to_address_city+"&currency="+currency+"&bill_to_forename="+bill_to_forename+"&signed_date_time="+signed_date_time
					+"&payment_method="+payment_method+"&override_custom_receipt_page="+override_custom_receipt_page+"&override_custom_cancel_page="+override_custom_cancel_page+"&reference_number="+reference_number+"&skip_decision_manager="+skip_decision_manager, response => {
					if(response.status) {
						self.setState({
							payload: {
								...self.state.payload,
								signature: response.responseObject.signature,
								access_key: response.responseObject.access_key,
								profile_id: response.responseObject.profile_id,
								transaction_uuid: response.responseObject.transaction_uuid,
								signed_field_names: response.responseObject.signed_field_names,
								signed_date_time: response.responseObject.signed_date_time,
								locale: response.responseObject.locale,
								transaction_type: response.responseObject.transaction_type,
								// reference_number: response.responseObject.reference_number,
								payment_method: response.responseObject.payment_method,
								bill_to_address_country: response.responseObject.bill_to_address_country
							}
						}, () => {
							document.payment_confirmation.accessKey = response.responseObject.access_key;
							document.payment_confirmation.action = cyberSourceURL;
							document.payment_confirmation.target ="_self";
							document.payment_confirmation.submit();
						});
					} else if(response.error || !response.status) { //In case error occured or status is false
						//We customize code for error handling
						self.setState({
							errorMessage: response.responseMessage
						});
					}
				});
			});
		} else {
			self.handleDialog("PayByCreditCardOverlayDialog", true);
		}
	}

	isPriceOrderServiceIsDown() {
		const self = this,
			{ isPriceOrderServiceIsDown } = self.state.createOrderPayload[0];
		if (isPriceOrderServiceIsDown) {
			return "Backend system is down. Your actual pricing will be updated later.";
		}
		return "";
	}

	handleFetchOrderDetails(orderNumber, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		// const { orderStatus } = self.state;
		self.setState({
			getOrderDetailsCallCompleted: false,
			getOrderShippingDetailsCallCompleted: false,
		}, () => {
			self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.setState({
						getOrderDetailsCallCompleted: true
					}, () => {
						self.callbackAfterServiceCall(wheretoRedirect)
					});
				}
			});
			self.props.saveOrderShippingDetails(null);
			// if(orderStatus === 'Save') {
				self.props.getOrderShippingDetails(orderNumber, response => {
					if(!response.status || !response.responseObject) {
						self.setState({
							errorMessage: response.responseMessage
						})
					} else {
						self.setState({
							getOrderShippingDetailsCallCompleted: true,
							getOrderShippingDetailsData: response,
						}, () => {
							self.callbackAfterServiceCall(wheretoRedirect)
						});
					}
				});
			// } else {
			// 	self.setState({
			// 		getOrderShippingDetailsCallCompleted: true,
			// 		getOrderShippingDetailsData: null,
			// 	}, () => {
			// 		self.callbackAfterServiceCall(wheretoRedirect)
			// 	});
			// }
		});
	}

	callbackAfterServiceCall(wheretoRedirect) {
		const self = this;
		const { getOrderDetailsCallCompleted, getOrderShippingDetailsCallCompleted, getOrderShippingDetailsData } = self.state;
		if(getOrderDetailsCallCompleted && getOrderShippingDetailsCallCompleted) {
			self.props.saveOrderShippingDetails(getOrderShippingDetailsData);
			browserHistory.push('/' + wheretoRedirect);
		}
	}

	handleDeleteCart(event) {
		event.preventDefault();
		this.handleDialog("ConfirmDeleteCartOverlayDialog", true);
		localStorage.removeItem("RDDate")
	}

	redirectToStep1() {
		// hide the dialog
		this.handleDialog('AvailabilityMismatchAndUpdateActionOverlayDialog', false);
		// redirect user to previous step
		browserHistory.push('/order/createOrder');
	}

	deleteCart(event) {
		event.preventDefault();
		const self = this;
		self.props.saveCreateOrderPayloadBackup(null);
		self.handleRemoveAllCart(() => {
			browserHistory.push('/home')
		});
	}

	checkIfAnyInventoryFinancing(createOrderPayload) {
		const self = this;
		let inventoryFinancing = false;
		createOrderPayload.forEach(order => {
			order.items.forEach(item => {
				if(item.agreementNumber && self.props.checkInventoryFinancingSA(item.agreementNumber)) {
					inventoryFinancing = true;
				}
			});
		});
		return inventoryFinancing;
	}

	checkIfAnyItemIsNotHoldBackOrder() {
		const self = this;
		let flag = false;
		self.state.createOrderPayload.forEach(order => {
			if(!flag) {
				flag = order.items.find(item => item.onHold !== 'Y') ? true : false;
			}
		});
		return flag;
	}

	validateFP(item) {
		const self = this;
		let finalProductionDate = null;
		if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
			finalProductionDate = item.geego_final_production_date;
		}
		return self.props.checkIfFPExceptAvailability({
			finalProductionDate: finalProductionDate,
			etaDate: item.eta
		});
	}

	checkDBUpdatesY(items) {
		const list = [];
		items.forEach((itm, index) => {
			if (itm.dbholdflag === 'Y' && itm.onHold !== "Y") {
				list.push(
					<span key={index}>
						<br />{itm.item}
					</span>
				);
			}
		});
		return list.length
			? <p className="red">The below models on this order exceed the quoted amount. The order will be placed on hold. Please contact your ASM to request an update to the quote.
				{list}
			</p>
			: null
	}

    render() {
		const self = this;
		const { state } = this.props,
			{ createOrderPayload, editOrderErrorOccured } = this.state,
			{ userDetails, selectedPriceSource } = state.user,
			{ isOrderPlaced } = state.order;
		const isThisAccountRestricted = this.props.isThisAccountRestricted;
		const { selectedAccount, selectedAccountsAllPriceSources } = this.props.state.user;

		const { completedOrderId } = this.state;
		let orderNumbers = [];
		completedOrderId.forEach((itm, index) => {
			orderNumbers.push(itm.orderNumber);
		});
        return (
			<div>
				{createOrderPayload && createOrderPayload.length > 0
		            ?<div>
						{isOrderPlaced && <p className="textRight">
							<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Order Confirmation</a>
						</p>}
		                <div className="push">
							<h1 className="pageTitle">{isOrderPlaced?"Order Confirmation":"Order Review"}</h1>
		                    {/* or Order Confirmation */}
							{createOrderPayload && createOrderPayload.find(itm => itm.hideEstimateGEAADCMsg) &&
								<p className="orange">Products can only be placed on Backorder Hold when the order is booked, so backordered items have been Entered with the rest of the order. Price, delivery charges and availability may change when the order is Booked.</p>
							}
		                </div>
						{editOrderErrorOccured && <p className="bold red">
							{editOrderErrorOccured}
							{self.state.orderNumberForError && <span>&nbsp;View Order Details <a href="" onClick={this.handleFetchOrderDetails.bind(this, self.state.orderNumberForError, 'orderdetails')}>{self.state.orderNumberForError}</a></span>}
						</p>}
						{!editOrderErrorOccured && <div>
			                {/* needed for Order Confirmation and Saved Order screens only */}
			                <div className="push">
								<p className="bold red">{self.isPriceOrderServiceIsDown()}</p>
								{isOrderPlaced
									?<p className="bold">Order {this.state.whichOrder === 'createorder' ? 'Reference' : ''} #: {orderNumbers.join(', ')}</p>
									:!orderNumbers?<p className="bold red"> Your order is not booked yet. Please try again to book the order</p>:null
								}
								{isOrderPlaced
									?<p>Account #: {selectedAccount && selectedAccount.ACCOUNTNUMBER} - {selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}</p>
									:null
								}
								<p className="bold red">{this.state.payByCreditCardError}</p>
								<p className="bold red">{this.state.errorMessage}</p>
								<p className="importantText bold">{!this.state.transactionId && !this.state.email && this.state.duplicatePOMsg}</p>
								<p className="bold">{this.state.confirmationMessage}</p>
			                </div>
							{createOrderPayload && createOrderPayload.map((item, index) => {
								const {
									shippingAddress,
									billingAddress,
									items,
								} = item;
								let orderNumber = '';
								if(isOrderPlaced) {
									const data = _.find(completedOrderId, {shipSet: items[0].shipSet});
									if(data) {
										orderNumber = data.orderNumber;
									}
								}
								let shippingData = createOrderPayload[0].shippingData ? createOrderPayload[0].shippingData: [];
								let deliveryMethodDataValue = item.deliveryMethod.split(" ")[0];
								let deliveryMethodData = "";
								if(deliveryMethodDataValue === "SDS"){
									deliveryMethodData = "sds_loc";
								}else if(deliveryMethodDataValue === "ADC" || deliveryMethodDataValue.split("-")[0] === "MATU"){
									deliveryMethodData = "adc_loc";
								}else if(deliveryMethodDataValue === "FedEx"){
									deliveryMethodData = "adc_loc";
								} if(item.deliveryMethod === "SDS Will Call"){
									deliveryMethodData = "sds_will_call_loc"
								}
								let warehouseData = {}
								if(createOrderPayload[0].alternateADC !== createOrderPayload[0].defaultAlternateADC || deliveryMethodDataValue === "SDS"){
									warehouseData = {
										label: createOrderPayload[0].warehouseCode,
										name: createOrderPayload[0].warehouseName
									}
								}
								else{
									if(createOrderPayload[0].isSDSWillCallValueUpdated && item.deliveryMethod === "SDS Will Call"){
										item.warehouseCodeForDisplay = item.warehouseCodeForDisplay;
										warehouseData = false;
									}else{
										let ADCdata = shippingData && shippingData.length > 1 ? shippingData.filter( data => data.loctype === deliveryMethodData ) : shippingData;
										let alternateADC = ADCdata && ADCdata.length > 0 ? ADCdata[0].agentid : ADCdata.agentid;
										warehouseData = self.props.state.user.adcList.find(itm => itm.label === alternateADC);
										if(!warehouseData){
											item.warehouseCodeForDisplay = `${deliveryMethodDataValue} - ${ADCdata.length > 0 ?ADCdata[0].agentid : ADCdata.agentid} ${ADCdata.length > 0 ? ADCdata[0].dockname : ADCdata.dockname}`
										}
									}
								}
								return <div key={index}>
									<div>
										<h2 style={{borderBottom: '1px solid #000'}}>
											{!item.hideEstimateGEAADCMsg && item.deliveryMethod !== 'ADC Velocity' && items && items[0].onHold !== 'Y' && item.applyBulkHold !== 'Y' && <span className="red estimated-ship-date">
												Target Arrival Date: {!(items && items[0].groupArrivalDate) || moment(items[0].groupArrivalDate, 'MM/DD/YYYY').isAfter(moment().add(routes.horizon, 'days')) ? 'Not Available' : moment.max(moment(item.requestedDeliveryDate || items[0].groupArrivalDate, 'MM/DD/YYYY'), moment(items[0].groupArrivalDate, 'MM/DD/YYYY')).format('MM/DD/YYYY')}
											</span>}
											<span className="delivery-seq-style">{index + 1}</span>
											<sup>{index === 0?'st':(index === 1?'nd':(index === 2?'rd':'th'))}</sup> Delivery{items.length > 0 && items[0].onHold === 'Y' && <span>&nbsp;- Backorder</span>}
										</h2>
										{isOrderPlaced && self.checkDBUpdatesY(items)}
										<div className="push orderReviewColumns columns threeColumns">
						                    <div className="orderReviewColumn column column1">
						                        <p>
													{isOrderPlaced && (this.state.whichOrder === 'createorder' || (this.state.whichOrder === 'editorder' && this.state.createOrderPayload.length > 1)) &&
														<span>
															<strong>Order {this.state.whichOrder === 'createorder' ? 'Reference' : ''} #:</strong>&nbsp;
															{orderNumber}<br/>
														</span>
													}
													<strong>Status</strong>:&nbsp;{isOrderPlaced?`Order has been ${this.state.createOrderPayload[0].orderStatus === 'Create'?'booked':'entered'}`:`Order has ${this.state.whichOrder === 'editorder' ? '' : 'not yet'} been entered`}
													<br />
													{warehouseData
														?<span><strong>Warehouse</strong>: {`${warehouseData.label} ${warehouseData.name}`}<br /></span>
														:<span><strong>Warehouse</strong>: {item.warehouseCodeForDisplay}<br /></span>	
													}
						                            <strong>Order Date</strong>:  {item.orderDate}<br />
						                            <strong>Order started by</strong>: {state.user.userDetails.firstName + " " + state.user.userDetails.lastName}<br />
						                            <strong>P.O.#</strong>:  {item.poNumber && item.poNumber.toUpperCase()}<br /><br />
						                            {/* Dynamic entries below, add as many as needed: */}
													{item.billingReference && item.billingReference.map((itm, indx) => {
														return <span key={indx}><strong>{itm.name}</strong>:  {itm.value}<br /></span>
													})}
													{/*item.alternateADC && <span><strong>ADC</strong>:  {item.alternateADC}<br /></span>*/}
						                        </p>
						                    </div>
						                    <div className="orderReviewColumn column column2">
												{shippingAddress && <p>
						                            <strong>Ship to</strong>:<br />
													{self.props.showOtherFieldsInAddShippingAddress
														? shippingAddress.firstName && shippingAddress.lastName
															? <span>
																{`${shippingAddress.firstName} ${shippingAddress.lastName}`}
																<br />
															</span>
															: null
														: <span>
															{shippingAddress.name}{shippingAddress.name ? <br /> : null}
														</span>
													}
													{shippingAddress.address1 && shippingAddress.address1.trim()}
													{shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
													{shippingAddress.address2 && shippingAddress.address2.trim()}
													{shippingAddress.address2 && shippingAddress.address2.trim() !== ""?<br/>:null}
													{shippingAddress.address3 && shippingAddress.address3.trim()}
													{shippingAddress.address3 && shippingAddress.address3.trim() !== ""?<br/>:null}
													{shippingAddress.city && shippingAddress.city.trim()}, {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}<br />
													{shippingAddress.phone && this.props.normalizePhoneNumber(shippingAddress.phone.trim())}
						                        </p>}
						                        <p>
						                            <strong>Delivery Phone</strong>: {item.deliveryPhone}<br />
													<strong>Shipping Instructions</strong>: {item.deliveryInstructions && item.deliveryInstructions.trim()}<br />
						                        </p>
												{isOrderPlaced && item.customerServiceNotesOrg && <p style={{wordBreak: 'break-all'}}>
													<strong>Notes To Customer Service</strong>: {item.customerServiceNotesOrg}
												</p>}
						                    </div>
						                    <div className="orderReviewColumn column column3">
												{selectedPriceSource && selectedPriceSource.BILL_TO_LOCATION
													?<p>
														<strong>Bill to</strong>:<br />
														{selectedPriceSource.BILL_TO_LOCATION}
													</p>
													:(billingAddress && <p>
							                            <strong>Bill to</strong>:<br />
														{billingAddress.name}<br />
														{billingAddress.address1 && billingAddress.address1.trim()}
														{billingAddress.address1 && billingAddress.address1.trim() !== ""?<br/>:null}
														{billingAddress.address2 && billingAddress.address2.trim()}
														{billingAddress.address2 && billingAddress.address2.trim() !== ""?<br/>:null}
														{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()} {billingAddress.zip && billingAddress.zip.trim()}<br />
														{billingAddress.phone && this.props.normalizePhoneNumber(billingAddress.phone.trim())}<br/>
							                        </p>)
												}
						                        <p>
													{item.deliveryTerms
														?<span><strong>Delivery Terms</strong>: {item.deliveryTerms}<br /></span>
														:null
													}
						                            <strong>Shipping Method</strong>: {item.deliveryMethod}<br />
						                            <strong>Requested Delivery Date</strong>: {item.requestedDeliveryDate && this.props.formatDate(item.requestedDeliveryDate, 'MM/DD/YY')}<br />
						                        </p>
						                    </div>
						                </div>
										<table className="orderReviewTable dataTableType2 noRowBorders milktoast">
						                    <thead>
						                        <tr>
						                            <th className="product" style={{width: 'max-content'}}>Product</th>
						                            <th className="priceSource">Sales Agreement</th>
													<th className="availability" style={{width: 'max-content'}}>Avail</th>
						                            <th className="etaDate" style={{textAlign: 'center'}}>Target Arrival Date</th>
						                            <th className="" style={{textAlign: 'center'}}>Quantity</th>
													<th className="poNumber">P.O.</th>
						                            <th className="price" style={{textAlign: 'right'}}>
														{self.props.getSelectedAccountType() === 'RETAIL'?"Net Price":"Price"}<br />
														<span className="unbold">(Each)</span>
						                            </th>
						                            <th className="extendedPrice" style={{textAlign: 'right'}}>
						                                Extended<br />Net Price
						                                {/* or Extended Net Price */}
						                            </th>
						                        </tr>
						                        <tr><th className="toast" colSpan={8}></th></tr>
						                    </thead>
						                    <tbody>
												{items.map((itm, ind) => {
													// DO not show cancel items for edit order on review page
													if (self.state.whichOrder === "editorder" && itm.action === 'cancel') {
														return null;
													}
													let agreementName = "";
													if(selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject) {
														agreementName = _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: parseInt(itm.agreementNumber, 10)});
														agreementName = agreementName ? agreementName.AGREEMENT_NAME : "";
													}
													let availability = itm.availability;
													if (itm.geego_distribution_start_date && moment(itm.geego_distribution_start_date).isAfter(moment())) {
														availability = 'NEW';
													}
													return [
														<tr key={ind}>
								                            <td className="product" style={{width: 'max-content'}}>
																{itm.unrelatedOriginalItem? itm.unrelatedOriginalItem : itm.item}
															</td>
															<td className="priceSource">{agreementName}</td>
								                            <td className={`availability ${itm.originalOrderNumber ? 'green-text' : ''}`} style={{width: 'max-content'}}>
																{itm.originalOrderNumber && self.props.getWarehouseCodeDetailsFromBackOrBulkOrder(itm.originalOrderNumber)}
																{!itm.originalOrderNumber && availability}
															</td>
								                            <td className="etaDate">
																{!itm.originalOrderNumber && !(itm.availability >= itm.quantity) && itm.itmType !== "S"
																	? (self.validateFP(itm) ? 'FP' : self.props.checkETA(itm.eta, itm.geego_distribution_start_date))
																	: null
																}
															</td>
								                            <td className="quantity" style={{textAlign: 'center'}}>{itm.quantity}</td>
															<td className="poNumber">{itm.poNumber && itm.poNumber.toUpperCase()}</td>
								                            <td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
								                            <td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(itm.extendedPrice, 0, ".", ",", false, "$")}</td>
								                        </tr>,
														itm.relatedServices?
															itm.relatedServices.map((it, id) => {
																if(it.type === "BAG") {
																	return <tr key={id}>
											                            <td className="product" style={{width: 'max-content'}}> &nbsp; {it.serviceName}</td>
																		<td className="priceSource">{agreementName}</td>
											                            <td className="availability" style={{textAlign: 'center'}}></td>
											                            <td className="etaDate"></td>
											                            <td className="quantity" style={{textAlign: 'center'}}>{it.quantity}</td>
																		<td className="poNumber">{itm.poNumber && itm.poNumber.toUpperCase()}</td>
											                            <td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(it.price, 0, ".", ",", false, "$")}</td>
											                            <td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(it.extendedPrice, 0, ".", ",", false, "$")}</td>
											                        </tr>
																};
																return <tr key={id}>
										                            <td className="product" style={{width: 'max-content'}}> &nbsp; {it.serviceId}</td>
																	<td className="priceSource">{agreementName}</td>
										                            <td className="availability" style={{textAlign: 'center'}}></td>
										                            <td className="etaDate"></td>
										                            <td className="quantity" style={{textAlign: 'center'}}>{it.quantity}</td>
																	<td className="poNumber">{it.poNumber && it.poNumber.toUpperCase()}</td>
										                            <td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(it.price, 0, ".", ",", false, "$")}</td>
										                            <td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(it.extendedPrice, 0, ".", ",", false, "$")}</td>
										                        </tr>
															}):
														null
													]
												})}
						                    </tbody>
						                    <tfoot>
						                        <tr>
						                            <td colSpan={4}>Total Products</td>
						                            <td className="quantity" style={{textAlign: 'center'}}>{item.quantity}</td>
													<td>&nbsp;</td>
						                            <td>&nbsp;</td>
						                            <td className="extendedPrice" style={{textAlign: 'right'}}></td>
						                        </tr>
						                    </tfoot>
						                </table>
									</div>

									<div className="orderReviewPoints">
										<p className="netOrderPoints">
											<strong>Order Points:</strong> {item.pointValue}
										</p>
									</div>
									<table className="subtotalTable orderReviewSubtotalTable">
										<tbody>
											<tr className="subtotal">
												<td>Subtotal:</td>
												<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(item.orderSubTotal, 0, ".", ",", false, "$")}</td>
											</tr>
											{item.tariffSurcharge && <tr className="tax">
												<td>Tariff Surcharge:</td>
												<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(item.tariffSurcharge, 0, ".", ",", false, "$")}</td>
											</tr>}
											<tr className="tax">
												<td>Estimated Tax:</td>
												<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(item.estimatedTax, 0, ".", ",", false, "$")}</td>
											</tr>
											<tr className="total">
												<td>Estimated Total:</td>
												<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(item.orderTotal, 0, ".", ",", false, "$")}</td>
											</tr>
										</tbody>
									</table>
								</div>
							})}
		                  	{/* *required* for both Order Review and Order Confirmation screens */}
							{!isOrderPlaced
								?<div>
									<div className="clear" />
				                    {/* Order Review screens only */}
				                    <p className="textRight push">
				                        <a className="bold" href="" onClick={this.handleDialog.bind(this, "AddCustomerServiceNotesOverlayDialog", true)}>Add Order Notes For Customer Service Review</a>
				                    </p>
				                    {/* Order Review screens only */}
									{ userDetails.typeOfUser !== 'employee' && !self.checkIfAnyInventoryFinancing(self.state.createOrderPayload) &&
									    self.checkIfAnyItemIsNotHoldBackOrder() &&
									    <p className="textRight push">
									        <a className="withIcon withCreditCardIcon noUnderline uppercase bold" href='' onClick={this.handlePayByCreditCard.bind(this)}>Pay by Credit Card</a>
									    </p>
									}
				                    {/* Order Review screens only */}
				                    <p className="floatRight textRight">
				                        <a className="blueButton" href="" onClick={this.handleReleaseOrder.bind(this)}>Book Order</a>
				                    </p>
									<p className="floatLeft textRight">
										{ this.state.whichOrder === "createorder" && <a className="blueButton" href="" onClick={this.handleDeleteCart.bind(this)}>Delete Cart</a>}
										&nbsp; &nbsp;
										{ !isThisAccountRestricted &&
											<a className="blueButton" href="" onClick={this.handleSaveOrder.bind(this)}>Enter Order</a>
										}
									</p>
				                    <div className="clear" />
				            	</div>
								:null
							}
						</div>}
					</div>
					:null
				}
				<form id="payment_confirmation" name="payment_confirmation" method="post">
					<input type="hidden" id="signature" name="signature" value={this.state.payload.signature}/>
				    <input type="hidden" name="access_key" value={this.state.payload.access_key}/>
		            <input type="hidden" name="profile_id" value={this.state.payload.profile_id}/>
		            <input type="hidden" id="transaction_uuid" name="transaction_uuid" value={this.state.payload.transaction_uuid} />
		            <input type="hidden" id="signed_field_names" name="signed_field_names" value={this.state.payload.signed_field_names}/>
		    	    <input type="hidden" id="signed_date_time" name="signed_date_time" value={this.state.payload.signed_date_time} />
				 	<input type="hidden" id="locale" name="locale" value={this.state.payload.locale}/>
			 		<input type="hidden" id="transaction_type" name="transaction_type" value={this.state.payload.transaction_type} />
					<input type="hidden" id="reference_number" name="reference_number" value={this.state.payload.reference_number} />
					<input type="hidden" id="skip_decision_manager" name="skip_decision_manager" value={this.state.payload.skip_decision_manager} />
  				 	<input type="hidden" id="amount" name="amount" value={this.state.payload.amount} />
					<input type="hidden" id="currency" name="currency"  value={this.state.payload.currency}/>
					<input type="hidden" id="payment_method" name="payment_method" value={this.state.payload.payment_method} />
					<input type="hidden" id="bill_to_forename" name="bill_to_forename" value={this.state.payload.bill_to_forename} />
					<input type="hidden" id="bill_to_surname" name="bill_to_surname" value={this.state.payload.bill_to_surname} />
					<input type="hidden" id="bill_to_middleinitial" name="bill_to_middleinitial" value={this.state.payload.bill_to_middleinitial}/>
					<input type="hidden" id="bill_to_email" name="bill_to_email" value={this.state.payload.bill_to_email}/>
					<input type="hidden" id="bill_to_address_line1" name="bill_to_address_line1" value={this.state.payload.bill_to_address_line1}/>
					<input type="hidden" id="bill_to_address_line2" name="bill_to_address_line2" value={this.state.payload.bill_to_address_line2}/>
					<input type="hidden" id="bill_to_address_city" name="bill_to_address_city" value={this.state.payload.bill_to_address_city}/>
					<input type="hidden" id="bill_to_address_state" name="bill_to_address_state" value={this.state.payload.bill_to_address_state}/>
					<input type="hidden" id="bill_to_address_country" name="bill_to_address_country" value={this.state.payload.bill_to_address_country}/>
					<input type="hidden" id="bill_to_address_postal_code" name="bill_to_address_postal_code" value={this.state.payload.bill_to_address_postal_code}/>
					<input type="hidden" id="bill_to_company_name" name="bill_to_company_name" value={this.state.payload.bill_to_company_name}/>
					<input type="hidden" id="override_custom_receipt_page" name="override_custom_receipt_page" value={this.state.payload.override_custom_receipt_page} />
					<input type="hidden" id="override_custom_cancel_page" name="override_custom_cancel_page" value={this.state.payload.override_custom_cancel_page} />
				</form>
				{/*<p className="bold">Disclaimer: Final tax will be calculated once the order is placed.</p>*/}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showAddCustomerServiceNotesOverlayDialog?<AddCustomerServiceNotesOverlayDialog handleAddNotes={this.handleAddNotes.bind(this)} customerServiceNotes={this.state.createOrderPayload && this.state.createOrderPayload[0].customerServiceNotes} showDialog={true} handleDialog={this.handleDialog}/>:null}
				{this.state.showConfirmDeleteCartOverlayDialog?<ConfirmDeleteCartOverlayDialog deleteCart={this.deleteCart.bind(this)} showDialog={true} handleDialog={this.handleDialog}/>:null}
				{this.state.showConfirmSaveYesNoOverlayDialog?<ConfirmSaveYesNoOverlayDialog updateOrderStatus={this.updateOrderStatus.bind(this)} showDialog={true} handleDialog={this.handleDialog} />:null}
				{this.state.showConfirmReleaseYesNoOverlayDialog?<ConfirmReleaseYesNoOverlayDialog updateOrderStatus={this.updateOrderStatus.bind(this)} showDialog={true} handleDialog={this.handleDialog} />:null}
				{this.state.showOrderStatusOverlayDialog?<OrderStatusOverlayDialog showDialog={true} handleDialog={this.handleDialog} />:null}
				{this.state.showConfirmReleaseSDSNextDayDeliveryDialog?<ConfirmReleaseSDSNextDayDeliveryDialog showDialog={true} handleDialog={this.handleDialog} updateOrderStatus={this.updateOrderStatus.bind(this)} />:null}
				{this.state.showPayByCreditCardOverlayDialog?<PayByCreditCardOverlayDialog showDialog={true} handleDialog={this.handleDialog}/>:null}
				{this.state.showAvailabilityMismatchAndUpdateActionOverlayDialog?<AvailabilityMismatchAndUpdateActionOverlayDialog showDialog={true} handleDialog={this.redirectToStep1.bind(this)}/>:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	cancelOrderDetails: (payload, queryStringParams, callback) => dispatch(cancelOrderDetails(payload, queryStringParams, callback)),
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
    saveToCart: (payload) => dispatch(saveToCart(payload)),
	getCyberSource: (queryString, callback) => dispatch(getCyberSource(queryString, callback)),
	saveCreateOrderPayloadBackup: (data) => dispatch(saveCreateOrderPayloadBackup(data)),
	saveIsOrderCreatedWithNewAddress: (data) => dispatch(saveIsOrderCreatedWithNewAddress(data)),
	isOrderPlaced: (data) => dispatch(isOrderPlaced(data)),
	decliningBalance: (params, callback) => dispatch(decliningBalance(params, callback)),
	saveOrderShippingDetails: (data) => dispatch(saveOrderShippingDetails(data)),
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	saveCreateOrderPayload: (data) => dispatch(saveCreateOrderPayload(data)),
	saveManageOrdersListBackup: (data) => dispatch(saveManageOrdersListBackup(data)),
	getTax: (payload, params, response) => dispatch(getTax(payload, params, response)),
	resetErrorDetails: () => dispatch(resetErrorDetails()),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
});

OrderReview = connect(mapStateToProps, mapDispatchToProps)(OrderReview);
export default OrderReview;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/orderReview.js